import { render } from "./teacherArchives.vue?vue&type=template&id=2632bf18&scoped=true"
import script from "./teacherArchives.vue?vue&type=script&lang=js"
export * from "./teacherArchives.vue?vue&type=script&lang=js"

import "./teacherArchives.vue?vue&type=style&index=0&id=2632bf18&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2632bf18"]])

export default __exports__